import React, { useRef } from 'react';
import { Rnd } from 'react-rnd';

function FocusArea({ focusRect, setFocusRect, imageWidth, imageHeight, zoomFactor }) {
  // focusRect: { x, y, width, height } in image coordinates
  // imageWidth, imageHeight: natural image size

  // Defensive: Provide defaults if focusRect is null or missing fields
  const safeRect = focusRect && typeof focusRect.x === 'number' && typeof focusRect.y === 'number' && typeof focusRect.width === 'number' && typeof focusRect.height === 'number'
    ? focusRect
    : { x: 0, y: 0, width: 100, height: 100 };

  // Clamp the rectangle within the image bounds
  const clamp = (val, min, max) => Math.max(min, Math.min(val, max));

  // Track resizing for fluid update
  const resizingRef = useRef(false);

  return (
    <Rnd
      bounds="parent"
      scale={zoomFactor}
      size={{ width: safeRect.width, height: safeRect.height }}
      position={{ x: safeRect.x, y: safeRect.y }}
      minWidth={32}
      minHeight={32}
      onDrag={(e, d) => {
        // Fluid drag
        setFocusRect(rect => {
          const r = rect && typeof rect.x === 'number' && typeof rect.y === 'number' && typeof rect.width === 'number' && typeof rect.height === 'number'
            ? rect
            : { x: 0, y: 0, width: 100, height: 100 };
          return {
            ...r,
            x: clamp(d.x, 0, imageWidth - r.width),
            y: clamp(d.y, 0, imageHeight - r.height)
          };
        });
      }}
      onDragStop={(e, d) => {
        setFocusRect(rect => {
          const r = rect && typeof rect.x === 'number' && typeof rect.y === 'number' && typeof rect.width === 'number' && typeof rect.height === 'number'
            ? rect
            : { x: 0, y: 0, width: 100, height: 100 };
          return {
            ...r,
            x: clamp(d.x, 0, imageWidth - r.width),
            y: clamp(d.y, 0, imageHeight - r.height)
          };
        });
      }}
      onResize={(e, direction, ref, delta, position) => {
        // Fluid resize
        setFocusRect(rect => {
          const r = rect && typeof rect.x === 'number' && typeof rect.y === 'number' && typeof rect.width === 'number' && typeof rect.height === 'number'
            ? rect
            : { x: 0, y: 0, width: 100, height: 100 };
          return {
            x: clamp(position.x, 0, imageWidth - ref.offsetWidth),
            y: clamp(position.y, 0, imageHeight - ref.offsetHeight),
            width: clamp(ref.offsetWidth, 32, imageWidth),
            height: clamp(ref.offsetHeight, 32, imageHeight)
          };
        });
      }}
      onResizeStop={(e, direction, ref, delta, position) => {
        setFocusRect(rect => {
          const r = rect && typeof rect.x === 'number' && typeof rect.y === 'number' && typeof rect.width === 'number' && typeof rect.height === 'number'
            ? rect
            : { x: 0, y: 0, width: 100, height: 100 };
          return {
            x: clamp(position.x, 0, imageWidth - ref.offsetWidth),
            y: clamp(position.y, 0, imageHeight - ref.offsetHeight),
            width: clamp(ref.offsetWidth, 32, imageWidth),
            height: clamp(ref.offsetHeight, 32, imageHeight)
          };
        });
      }}
      style={{
        border: '2px dashed #00eaff',
        background: 'rgba(0,234,255,0.08)',
        zIndex: 10,
        boxSizing: 'border-box',
        pointerEvents: 'auto',
      }}
    >
      <span className="focus-area-label" style={{ '--focus-label-scale': 1 / zoomFactor }}>Focus Area</span>
    </Rnd>
  );
}

export default FocusArea;
